import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'primereact/message';
import { Checkbox } from 'primereact/checkbox';
import ArrayUtil from '../../utils/ArrayUtil';
import { formikFormShape } from '../prop-types';


const PrimeReactErrorMessage = ({ msg }) => <Message severity="error" text={msg} />;

PrimeReactErrorMessage.propTypes = {
  msg: PropTypes.string.isRequired,
};

class FormCheckboxGroup extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = { allOptionsSelected: false };
  }

  handleInputChange(eventParams) {
    const { checked, value: selected } = eventParams;
    const { setFieldValue, field: { name, value }, options } = this.props;
    const currentValue = value || [];
    if (checked) {
      currentValue.push(selected);
      setFieldValue(name, currentValue);

      const allChecked = options.every(option => currentValue.indexOf(option.value) !== -1);

      if (allChecked) {
        this.setState({ allOptionsSelected: true });
      }
    } else {
      const newValue = value.filter(opt => opt !== selected);
      setFieldValue(name, newValue);
      this.setState({ allOptionsSelected: false });
    }
  }

  render() {
    const {
      options, field, form: { errors }, isErrorShown = true, displayName, setFieldValue,
    } = this.props;
    const { allOptionsSelected } = this.state;

    const checkboxes = options.map((option) => {
      const { value: optionValue } = option;
      const { value } = field;

      const existed = ArrayUtil.isNotEmpty(value)
        && value.find(opt => opt === optionValue);

      const checked = !!existed;
      return (
        <div key={option.value} className="p-col-12">
          <Checkbox
            inputId={`${field.name}.${option.value}`}
            onChange={this.handleInputChange}
            value={option.value}
            checked={checked}
          />
          <label
            htmlFor={`${field.name}.${option.value}`}
            className="p-checkbox-label"
          >
            {option.label}
          </label>
        </div>
      );
    });

    return (
      <>
        <i>
          {displayName}
        </i>
        {' '}
        <Checkbox
          onChange={(e) => {
            const optionValues = options.map(option => option.value);
            if (e.checked) {
              optionValues.forEach((optionValue) => {
                if (!field.value.includes(optionValue)) {
                  field.value.push(optionValue);
                  setFieldValue(field.name, field.value);
                }
              });
            } else {
              setFieldValue(field.name, field.value.filter(fv => !optionValues.includes(fv)));
            }
            this.setState({ allOptionsSelected: e.checked });
          }}
          checked={allOptionsSelected}
        />

        <hr />
        <div className="p-grid p-dir-col">
          {checkboxes}

          {
          isErrorShown
          && errors[field.name]
          && (<PrimeReactErrorMessage msg={errors[field.name]} />)
        }
        </div>
      </>
    );
  }
}

FormCheckboxGroup.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  form: formikFormShape.isRequired,
  isErrorShown: PropTypes.bool,
  displayName: PropTypes.string.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.objectOf(PropTypes.any).isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
};

FormCheckboxGroup.defaultProps = {
  isErrorShown: true,
};

export default FormCheckboxGroup;
